import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useSubsidiaryVatCodesApi } from "../../http/subsidiaryVatCodes/api";
import { UpsertSubsidiaryVatCode } from "../../http/subsidiaryVatCodes/types";
import SvgAdd from "../icons/Add";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";
import SubsidiaryVatCodeForm, { SubsidiaryVatCodeFormBody } from "./SubsidiaryVatCodeForm";

type CreateSubsidiaryVatCodesDialogProps = {
  subsidiaryId?: string;
};

const CreateSubsidiaryVatCodeButton: FC<CreateSubsidiaryVatCodesDialogProps> = ({
  subsidiaryId,
}: CreateSubsidiaryVatCodesDialogProps) => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const subVatCodesApi = useSubsidiaryVatCodesApi();

  const onSubmit = async (formData: SubsidiaryVatCodeFormBody) => {
    const body: UpsertSubsidiaryVatCode = {
      carCategory: formData.carCategory.value,
      vatCode: formData.vatCode,
      productCode: formData.productCode,
      subsidiaryId: subsidiaryId ?? formData.subsidiary.id,
    };

    setIsSubmitting(true);
    try {
      await subVatCodesApi.insertAdminSubVatCode(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.subsidiaryVatCodes.new}>
          <SubsidiaryVatCodeForm isDisabled={isSubmitting} onSubmit={onSubmit} isTab={!!subsidiaryId} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateSubsidiaryVatCodeButton;
